/**
 * Whether a line-clamped element hides some of its text: its content runs
 * past its box. A pixel of slack for subpixel line heights.
 */
export function clampHidesText(el: { scrollHeight: number; clientHeight: number }): boolean {
  return el.scrollHeight - el.clientHeight > 1;
}
